<div class="not-found">
    <p>
        ¡La página que estás buscando no fue encontrada!
    </p>
    <a routerLink="/home">Volver al inicio</a>
</div>